import { createFileRoute } from '@tanstack/react-router';
import { TenantMcpPage } from '@/features/tenant-admin/pages/TenantMcpPage';

export const Route = createFileRoute('/tenant-admin/mcp')({
  component: TenantMcpPage,
});
